import React, { FC, useRef } from 'react';
import styled from 'styled-components';
import { BoxV2, EmptyStateV2 } from '@cubeyou-team/hx-react-components';
import StackedChart from '../StackedChart';
import uniqid from 'uniqid';

const StyledDoubleChartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

type DoubleChartProps = {
  margin: any;
  data: any[];
  left: any;
  right: any;
  emptyDataMessage: string;
  limit: any;
  showItemsPreview?: boolean;
  tickProps?: any;
  tooltipContent?: (_d) => any;
};

const defaultMargin = {
  left: { top: 50, right: 50, bottom: 50, left: 100 },
  right: { top: 50, right: 50, bottom: 50, left: 20 }
};
const DoubleChart: FC<DoubleChartProps> = ({
  margin = defaultMargin,
  data,
  left,
  right,
  emptyDataMessage,
  limit = 'auto',
  showItemsPreview,
  tickProps,
  tooltipContent
}) => {
  const chartId = useRef(uniqid());
  const isEmpty = !data || data.length === 0;

  if (isEmpty) {
    return (
      <StyledDoubleChartWrapper>
        <BoxV2 minWidth='100%'>
          <EmptyStateV2
            icon='analytics'
            mainText={emptyDataMessage}
            size='large'
          />
        </BoxV2>
      </StyledDoubleChartWrapper>
    );
  }

  return (
    <StyledDoubleChartWrapper>
      <div style={{ width: '50%', height: '100%' }}>
        <StackedChart
          key={`stacked-bar-left-${chartId.current}`}
          label={left.label}
          limit={limit}
          axesProps={{
            xAxis: left.xAxis,
            zAxis: left.zAxis,
            showYAxis: true
          }}
          data={data}
          color={left.color}
          margin={margin.left}
          showItemsPreview={showItemsPreview}
          tickProps={tickProps}
          tooltipContent={tooltipContent}
        />
      </div>
      <div style={{ width: '50%', height: '100%' }}>
        <StackedChart
          key={`stacked-bar-right-${chartId.current}`}
          label={right.label}
          limit={limit}
          axesProps={{
            xAxis: right.xAxis,
            zAxis: right.zAxis,
            showYAxis: false
          }}
          data={data}
          color={right.color}
          margin={margin.right}
          showItemsPreview={showItemsPreview}
          tickProps={tickProps}
          tooltipContent={tooltipContent}
        />
      </div>
    </StyledDoubleChartWrapper>
  );
};
export default DoubleChart;
